import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpMinQuantityValidator
     * @memberof app
     *
     * @restrict A
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpMinQuantityValidator', pkpMinQuantityValidator);

    function pkpMinQuantityValidator(fieldKeyService) {
        return {
            restrict: 'A',
            scope: false,
            require: '^ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            var fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);

            ngModelCtrl.$validators.pkpMinQuantityValidator = function (
                modelValue
            ) {
                if (
                    !attr.pkpMinQuantityValidator ||
                    !modelValue ||
                    !modelValue[fieldKey.valueKey] ||
                    ngModelCtrl.$isEmpty(modelValue[fieldKey.valueKey].value)
                ) {
                    return true;
                }

                try {
                    var minQuantity;
                    if (isNaN(attr.pkpMinQuantityValidator)) {
                        minQuantity = scope.$eval(attr.pkpMinQuantityValidator);
                    } else {
                        minQuantity = attr.pkpMinQuantityValidator;
                    }

                    //if there is no minQuantity defined, the minimum value is set to 1
                    if (angular.isUndefined(minQuantity)) {
                        minQuantity = 1;
                    }

                    if (
                        new Decimal(
                            modelValue[fieldKey.valueKey].value
                        ).lessThan(new Decimal(minQuantity))
                    ) {
                        return false;
                    }
                } catch (e) {
                    return false;
                }

                return true;
            };

            attr.$observe('pkpMinQuantityValidator', function () {
                ngModelCtrl.$validate();
            });
        }
    }
})();
